import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { PtKendoGridDirective } from '../../../../_foundation/kendo/directives/pt-kendo-grid/pt-kendo-grid.directive';
import { AppConfig } from '../../../../app/app.config';
import { KendoGridColumnConfig, KendoGridDataConfig } from '../../../../_foundation/kendo/models/grid.models';
import { State } from '@progress/kendo-data-query';
import { ProjectDetailService } from '../../../../services/setup/project-detail.service';
import coaGridConfig from './project-detail-coa-grid.config';

@IonicPage()
@Component({
  selector: 'page-project-detail-coa-grid',
  templateUrl: 'project-detail-coa-grid.html',
})
export class ProjectDetailCoaGridPage {
  @ViewChild('grid') grid?: GridComponent;
  @ViewChild('ptKendoGrid') ptKendoGrid: PtKendoGridDirective;

  projectId: number;
  projectName: string;
  stageId?: number;
  locationId?: number;
  stageName?: string;
  locationName?: string;

  config = AppConfig.settings;
  loading: boolean = false;
  gridConfig: KendoGridColumnConfig = coaGridConfig;
  gridData: GridDataResult;
  gridDataConfig: KendoGridDataConfig;

  public state: State = {
    take: 15,
    sort: coaGridConfig.defaultSort,
  };

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private projectDetailService: ProjectDetailService) {
    this.projectId = this.navParams.get('projectId');
    this.projectName = this.navParams.get('projectName');
    this.stageId = this.navParams.get('stageId');
    this.stageName = this.navParams.get('stageName');
    this.locationId = this.navParams.get('locationId');
    this.locationName = this.navParams.get('locationName');

    this.gridDataConfig = this.stageId
      ? this.projectDetailService.getCoaGridDataConfigForStage(this.stageId)
      : this.projectDetailService.getCoaGridDataConfigForLocation(this.locationId);
  }

  ionViewDidLoad() {
    this.loadGrid();
  }

  private loadGrid(): void {
    if (this.ptKendoGrid) {
      this.ptKendoGrid.updateGrid().subscribe(res => {
        this.gridData = res;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-coa-grid/project-detail-coa-grid.ts